import globalData from '@kk-activity-factory/global-data';

export function interceptSlide() {
    // 针对安卓端处理H5横向滚动和客户端tab切换的冲突
    if (!globalData.isApple && window.kkmh && window.kkmh.interceptSlide) {
        window.kkmh.interceptSlide(JSON.stringify({ direction: 3 }));
    }
}
